module.exports = __webpack_public_path__ + "img/NBL1.30d89774.png";